import { Component, OnInit } from '@angular/core';
import { RequestTypeEnum } from '../../../shared/xatena-api/request-type';
import { DemandRequestDetailService } from '../demand-request-detail.service';
import { RequestTypeBaseComponent } from '../request-type-base/request-type-base.component';
import { RequestDto } from '../../../xatena-api';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { AutoUnsubscribe } from '../../../core/auto-unsubscribe';
import { SubSink } from 'subsink';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { of } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';

@AutoUnsubscribe()
@Component({
  selector: 'app-request-type-investment',
  templateUrl: './request-type-investment.component.html',
  styleUrls: ['./request-type-investment.component.scss'],
  imports: [FormlyModule, AsyncPipe, MatDatepickerModule, MatNativeDateModule],
})
export class RequestTypeInvestmentFhnwComponent
  extends RequestTypeBaseComponent
  implements OnInit
{
  subs = new SubSink();

  public get rekoleCategorySelectList$() {
    return this.demandRequestDetailService.rekoleCategorySelectList$;
  }

  constructor(
    private translateService: TranslateService,
    demandRequestDetailService: DemandRequestDetailService
  ) {
    super(demandRequestDetailService);
  }

  public get procedureSelectList$() {
    const options: {
      key: number;
      value: string;
    }[] = [
      {
        key: 0,
        value: this.translateService.instant('SHARED.PROCEDURE_SELECT.OPEN'),
      },
      {
        key: 1,
        value: this.translateService.instant(
          'SHARED.PROCEDURE_SELECT.SELECTIVE'
        ),
      },
      {
        key: 2,
        value: this.translateService.instant(
          'SHARED.PROCEDURE_SELECT.FREEHAND'
        ),
      },
    ];

    return of(options);
  }

  public get orderTypeSelectList$() {
    const options: {
      key: number;
      value: string;
    }[] = [
      {
        key: 0,
        value: this.translateService.instant(
          'SHARED.ORDER_TYPE_SELECT.DELIVERY'
        ),
      },
      {
        key: 1,
        value: this.translateService.instant(
          'SHARED.ORDER_TYPE_SELECT.SERVICE'
        ),
      },
    ];

    return of(options);
  }

  public get procurementTypeSelectList$() {
    const options: {
      key: number;
      value: string;
    }[] = [
      {
        key: 0,
        value: this.translateService.instant(
          'SHARED.PROCUREMENT_TYPE_SELECT.DIRECT_PURCHASE'
        ),
      },
      {
        key: 1,
        value: this.translateService.instant(
          'SHARED.PROCUREMENT_TYPE_SELECT.FRAME_AGREEMENT'
        ),
      },
    ];

    return of(options);
  }

  private updateTotalCost(request: RequestDto) {
    // const costInvestmentTotal =
    //     +(request.costNet ?? 0) +
    //     +(request.costConstruction ?? 0) +
    //     +(request.costInstallation ?? 0) +
    //     +(request.costIT ?? 0) +
    //     +(request.costTraining ?? 0) +
    //     +(request.costOthers ?? 0);
    // this.form.get('costInvestmentTotal')?.setValue(costInvestmentTotal, {
    //     emitEvent: false,
    // });
    // const costUsageYears = +(request.costUsageYears ?? 0);
    // const costRecurringTotal =
    //     +(request.costRecurringMaintenance ?? 0) +
    //     +(request.costRecurringConsumables ?? 0) +
    //     +(request.costRecurringOthers ?? 0);
    // this.form.get('costRecurringTotal')?.setValue(costRecurringTotal, {
    //     emitEvent: false,
    // });
    // let costTotal = costInvestmentTotal;
    // if (costRecurringTotal > 0 && costUsageYears > 0) {
    //     costTotal += costRecurringTotal * costUsageYears;
    // }
    // this.form.get('costTotal')?.setValue(costTotal, {
    //     emitEvent: false,
    // });
  }

  ngOnInit(): void {
    this.subs.sink = this.form.valueChanges.subscribe(s => {
      // this.updateTotalCost(s);
    });

    this.fields = [
      {
        hooks: {
          onInit: field => {
            this.subs.sink = this.isReadOnly$.subscribe(s => {
              if (s) {
                this.form.disable();
              } else {
                this.form.enable();
              }
            });
          },
        },
        hideExpression: model =>
          !(model.requestTypeId === RequestTypeEnum.Investment),
        fieldGroup: [
          {
            wrappers: ['mat-card'],
            templateOptions: {
              label: _('DEMAND_REQUEST.DETAIL.FORM.REQUEST_TYPE_1_GRP_1.LABEL'),
              translate: true,
            },
            fieldGroup: [
              {
                key: 'description',
                type: 'textarea',
                templateOptions: {
                  required: true,
                  appearance: this.formFieldAppearance,
                  label: _('DEMAND_REQUEST.DETAIL.FORM.DESCRIPTION.LABEL'),
                  translate: true,
                  autosize: true,
                  autosizeMinRows: 3,
                  autosizeMaxRows: 7,
                },
              },
              {
                key: 'procurementType',
                type: 'select',
                templateOptions: {
                  required: true,
                  appearance: this.formFieldAppearance,
                  label: _('DEMAND_REQUEST.DETAIL.FORM.PROCUREMENT_TYPE.LABEL'),
                  translate: true,
                  options: this.procurementTypeSelectList$,
                  valueProp: 'key',
                  labelProp: 'value',
                },
              },
              {
                fieldGroupClassName: 'row',
                fieldGroup: [
                  {
                    className: 'col',
                    key: 'testDurationStart',
                    type: 'datepicker',
                    templateOptions: {
                      required: true,
                      appearance: this.formFieldAppearance,
                      label: _(
                        'DEMAND_REQUEST.DETAIL.FORM.TEST_DURATION_START.LABEL'
                      ),
                      translate: true,
                    },
                  },
                  {
                    className: 'col',
                    key: 'testDurationEnd',
                    type: 'datepicker',
                    templateOptions: {
                      required: true,
                      appearance: this.formFieldAppearance,
                      label: _(
                        'DEMAND_REQUEST.DETAIL.FORM.TEST_DURATION_END.LABEL'
                      ),
                      translate: true,
                    },
                  },
                ],
              },
            ],
          },
          {
            wrappers: ['mat-card'],
            templateOptions: {
              label: _('DEMAND_REQUEST.DETAIL.FORM.REQUEST_TYPE_1_GRP_2.LABEL'),
              translate: true,
            },
            fieldGroup: [
              {
                key: 'id',
                type: 'request-products-grid',
                templateOptions: {
                  translate: true,
                  currency: this.currency$,
                  requestTypeId: this.requestTypeId$,
                  colDef: [
                    {
                      headerName: _(
                        'DEMAND_REQUEST.DETAIL.PRODUCTS.GRID.COL.TITLE'
                      ),
                      field: 'title',
                      flex: 1,
                    },
                  ],
                },
              },
            ],
          },
          {
            wrappers: ['mat-card'],
            templateOptions: {
              label: _('DEMAND_REQUEST.DETAIL.FORM.REQUEST_TYPE_1_GRP_3.LABEL'),
              translate: true,
            },
            fieldGroup: [
              {
                key: 'budgetYear',
                type: 'input',
                templateOptions: {
                  type: 'number',
                  required: false,
                  appearance: this.formFieldAppearance,
                  label: _('DEMAND_REQUEST.DETAIL.FORM.BUDGET_YEAR.LABEL'),
                  translate: true,
                },
                validators: {
                  min: {
                    expression: (c: any, field: FormlyFieldConfig) => {
                      const minValue = new Date().getFullYear() - 1;

                      const res = Validators.min(minValue)(c);
                      if (!res) return { min: true };
                      return null;
                    },
                    message: (error: any, field: FormlyFieldConfig) => {
                      const minValue = new Date().getFullYear() - 1;

                      return this.translateService.stream(
                        'DEMAND_REQUEST.DETAIL.FORM.BUDGET_YEAR.VALIDATION.MIN',
                        { min: minValue }
                      );
                    },
                  },
                  max: {
                    expression: (c: any, field: FormlyFieldConfig) => {
                      const maxValue = new Date().getFullYear() + 6;

                      const res = Validators.max(maxValue)(c);
                      if (!res) return { max: true };
                      return null;
                    },
                    message: (error: any, field: FormlyFieldConfig) => {
                      const maxValue = new Date().getFullYear() + 6;

                      return this.translateService.stream(
                        'DEMAND_REQUEST.DETAIL.FORM.BUDGET_YEAR.VALIDATION.MAX',
                        { max: maxValue }
                      );
                    },
                  },
                },
              },
              {
                key: 'zsvaStatement',
                type: 'checkbox',
                templateOptions: {
                  required: false,
                  appearance: this.formFieldAppearance,
                  label: _('DEMAND_REQUEST.DETAIL.FORM.ZSVA_STATEMENT.LABEL'),
                  translate: true,
                },
              },
              {
                key: 'reason',
                type: 'textarea',
                templateOptions: {
                  required: false,
                  appearance: this.formFieldAppearance,
                  label: _('DEMAND_REQUEST.DETAIL.FORM.REASON.LABEL'),
                  translate: true,
                  autosize: true,
                  autosizeMinRows: 3,
                  autosizeMaxRows: 7,
                },
              },

              {
                className: 'rekole-select-container',
                key: 'rekoleCd',
                type: 'rekole-select',
                templateOptions: {
                  required: false,
                  appearance: this.formFieldAppearance,
                  label: _('DEMAND_REQUEST.DETAIL.FORM.REKOLE_CATEGORY.LABEL'),
                  translate: true,
                  options: this.rekoleCategorySelectList$,
                  valueProp: 'key',
                  labelProp: 'value',
                },
              },
              {
                key: 'location',
                type: 'textarea',
                templateOptions: {
                  required: false,
                  appearance: this.formFieldAppearance,
                  label: _('DEMAND_REQUEST.DETAIL.FORM.LOCATION.LABEL'),
                  translate: true,
                  autosize: true,
                  autosizeMinRows: 3,
                  autosizeMaxRows: 7,
                },
              },
            ],
          },
          {
            wrappers: ['mat-card'],
            templateOptions: {
              label: _('DEMAND_REQUEST.DETAIL.FORM.REQUEST_TYPE_1_GRP_4.LABEL'),
              translate: true,
            },
            fieldGroup: [
              {
                key: 'staffRequirementReasonType',
                type: 'select',
                templateOptions: {
                  required: false,
                  appearance: this.formFieldAppearance,
                  label: _(
                    'DEMAND_REQUEST.DETAIL.FORM.STAFF_REQUIREMENT_REASON_TYPE.LABEL'
                  ),
                  translate: true,
                  options: this.orderTypeSelectList$,
                  valueProp: 'key',
                  labelProp: 'value',
                },
              },
              {
                key: 'staffRequirementImpactType',
                type: 'select',
                templateOptions: {
                  required: false,
                  appearance: this.formFieldAppearance,
                  label: _(
                    'DEMAND_REQUEST.DETAIL.FORM.STAFF_REQUIREMENT_IMPACT_TYPE.LABEL'
                  ),
                  translate: true,
                  options: this.procedureSelectList$,
                  valueProp: 'key',
                  labelProp: 'value',
                },
              },
              {
                key: 'projectnr',
                type: 'input',
                templateOptions: {
                  required: false,
                  appearance: this.formFieldAppearance,
                  label: _('DEMAND_REQUEST.DETAIL.FORM.PROJECTNR.LABEL'),
                  translate: true,
                },
              },
            ],
          },
        ],
      },
    ];
  }
}
